// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"40504e1e","154":"bb80c89f","283":"d782a15d","349":"42c4e667","451":"e4def190","670":"17df121c","815":"f503f151","846":"c8ec25e9","858":"111e5fbc","918":"f1e9fd70"}[chunkId] + ".chunk.js";
};